import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      reqLoading: false,
      formData: {
        id: "",
        sdk_name: "",
        sdk_type: "",
        params: []
      },
      copyPramsKeyData: null,
      typeList: [{
        label: "字符串",
        value: "string"
      }, {
        label: "数字",
        value: "number"
      }, {
        label: "布尔值",
        value: "boolean"
      }, {
        label: "字典",
        value: "map"
      }, {
        label: "列表",
        value: "array"
      }],
      typeArrayList: [{
        label: "字典",
        value: "map"
      }],
      typeArrayValue: "map",
      rules: {
        sdk_name: [{
          required: true,
          message: "sdk名称",
          trigger: "blur"
        }],
        sdk_type: [{
          required: true,
          message: "sdk类型",
          trigger: "blur"
        }],
        params: [{
          required: true,
          message: "请添加参数",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  datas.params = _this.$utils.transformObject(JSON.parse(datas.params));
                  _this.formData = _objectSpread({}, datas);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.params.push({
        stringKey: '',
        stringVal: '',
        typeValue: 'string',
        mapParams: "",
        mapData: [],
        arrayParams: '',
        arrayData: [],
        numberKey: '',
        numberVal: '',
        booleanKey: '',
        booleanVal: ''
      });
    },
    removeContent: function removeContent(index) {
      // var index = this.formData.params.indexOf(item);
      // if (index !== -1) {
      this.formData.params.splice(index, 1); // }
    },
    removeMapItem: function removeMapItem(index, idx) {
      this.formData.params[index].mapData.splice(idx, 1);
    },
    removeArrayItem: function removeArrayItem(index, idx, k) {
      this.formData.params[index].arrayData[idx].arrChildrenItem.splice(k, 1);
    },
    addMapData: function addMapData(index) {
      this.formData.params[index].mapData.push({
        key: "",
        value: ""
      });
    },
    addArrayData: function addArrayData(index) {
      this.formData.params[index].arrayData.push({
        arrChildrenItem: []
      });
    },
    addArrayItemData: function addArrayItemData(index, idx) {
      this.formData.params[index].arrayData[idx].arrChildrenItem.push({
        key: "",
        value: ""
      });
    },
    removeItemContent: function removeItemContent(index, idx) {
      this.formData.params[index].arrayData.splice(idx, 1);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      var PramsKeyData = JSON.parse(JSON.stringify(this.formData.params));
      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 11;
                    break;
                  }

                  _this2.reqLoading = true;
                  _this2.copyPramsKeyData = _this2.$utils.dealTypeData(PramsKeyData); //处理数据不重复

                  _context2.next = 5;
                  return _this2.$utils.mergeData(_this2.copyPramsKeyData);

                case 5:
                  _this2.copyPramsKeyData = _context2.sent;
                  data = JSON.parse(JSON.stringify(_this2.formData)); // if (this.formData.id) {
                  //   await this.secondConfirmation()
                  // }

                  data.params = JSON.stringify(_this2.copyPramsKeyData);
                  console.log("data.params===", data.params);
                  reqFn = data.id ? 'adChannelSdkTypeUpdate' : 'adChannelSdkTypeAdd';

                  _this2.$api[reqFn](data).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  }).finally(function () {
                    _this2.reqLoading = false;
                  });

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};